export default () => {
  // const follower = jQuery("#footer-wrapper-container");
  // const wrapper = jQuery(".js-parallax").parent();
  // const container = jQuery(".js-parallax");
  // jQuery(document).on("scroll", function () {
  //   //const offsetTop = Math.round(jQuery(".js-parallax").parent().offset().top);
  //   const offsetTop = Math.round(follower.position().top);
  //   const scrollY = window.scrollY;
  //   const diffY = offsetTop - scrollY - 550;
  //   console.log(
  //     "offsetTop",
  //     Math.min(window.innerHeight, window.innerHeight - (offsetTop - scrollY))
  //   );
  //   //console.log("diffY", diffY);
  //   const translateY = Math.min(window.innerHeight, window.innerHeight - diffY);
  //   //console.log("diffY, translateY", diffY, translateY);
  //   //jQuery(".js-parallax").css("transform", `translateY(-${translateY / 2}px)`);
  //   //jQuery("#footer-wrapper-container");
  //   container.css("padding", "25px");
  //   container.css("width", "100vw");
  //   container.css("height", "550px");
  //   wrapper.css("height", "75px");
  //   wrapper.css("position", "fixed");
  //   wrapper.css("z-index", " 9999");
  //   wrapper.css("left", "0px");
  //   wrapper.css("top", `${translateY * -1}px`);
  // });
};
